import { useSearchParams } from 'react-router-dom';
import { VISIBILITY_KEYS } from '../../../utils/constants/visibilityKeys';
import { useFeatureVisibility } from '../../../utils/useVisibilityConfig';

const useProfileButtonLogic = () => {
    const [params, setParams] = useSearchParams();
    const { magicSignGlobalVisibility } = useFeatureVisibility({
        magicSignGlobalVisibility: VISIBILITY_KEYS.MAGIC_SIGN.GLOBAL,
    });

    const openGlobalMagicSign = () => {
        params.set('magicSign', 'true');
        params.delete('isCompany');
        params.delete('orgId');
        params.delete('companyName');
        // Clear any stale needInfo — the drawer's default-tab priority is needInfo > magicSign, so a
        // lingering needInfo=true (from a prior Data Requests visit) would open the drawer on the
        // (non-rendered, global-context) Data Requests tab instead of the global Magic Sign view.
        params.delete('needInfo');
        setParams(params);
    };

    return { magicSignGlobalVisibility, openGlobalMagicSign };
};

export default useProfileButtonLogic;
